export default "__VITE_ASSET__6iuAYrer__"